import IndexModel from "@/service/v1/sigap/IndexModel";

class EspacoService extends IndexModel {
    constructor() {
        super();
        this.url = this.url + '/EspacoLocavel';
    }

    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }

    public getModel(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(this.url + '/' + id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    public getStatus(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(this.url + '/GetStatus', {})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }
}

export default EspacoService;
